<template>
  <div class="mb-12 p-8 px-0 lg:pt-24 lg:pl-24 lg:pr-24 md:px-8" :class="{ 'th-menu-shadow' : !locationBottom, 'th-menu-shadow-up' : locationBottom, 'pb-0': locationBottom, 'lg:pb-24': !locationBottom}">
    <div class="header-nav-buttons w-full flex justify-evenly text-center mb-16">
      <div @click="setCurrentTab('grouppois')">
          <div class="mainmenu-item" :class="{ active: currentTab == 'grouppois' }">
            <svg width="19" height="24" viewBox="0 0 19 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10.911 23.4C13.3157 20.3906 18.8 13.0969 18.8 9C18.8 4.03125 14.7688 0 9.80005 0C4.8313 0 0.800049 4.03125 0.800049 9C0.800049 13.0969 6.28442 20.3906 8.68911 23.4C9.26567 24.1172 10.3344 24.1172 10.911 23.4ZM9.80005 6C10.5957 6 11.3588 6.31607 11.9214 6.87868C12.484 7.44129 12.8 8.20435 12.8 9C12.8 9.79565 12.484 10.5587 11.9214 11.1213C11.3588 11.6839 10.5957 12 9.80005 12C9.0044 12 8.24134 11.6839 7.67873 11.1213C7.11612 10.5587 6.80005 9.79565 6.80005 9C6.80005 8.20435 7.11612 7.44129 7.67873 6.87868C8.24134 6.31607 9.0044 6 9.80005 6Z" fill="#0F417C"/>
            </svg>
          </div>
          <div class="btn-label text-16 md:text-18">
            <WFTranslate k="map">Map</WFTranslate>
          </div>
        </div>
        <div @click="setCurrentTab('flights')">
          <div class="mainmenu-item" :class="{ active: currentTab == 'flights' }">
            <svg width="29" height="24" viewBox="0 0 29 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M23.6525 15C25.281 15 28.1144 13.6406 28.1144 12C28.1144 10.3125 25.281 9 23.6525 9H18.1001L13.3144 0.754688C13.0429 0.285938 12.5382 0 11.9906 0H9.31436C8.8096 0 8.44293 0.478125 8.58103 0.956249L10.9144 9H6.01912L3.96198 6.3C3.81912 6.1125 3.59055 6 3.35246 6H1.35246C0.981029 6 0.685791 6.29531 0.685791 6.65625C0.685791 6.71719 0.695315 6.77812 0.709601 6.83906L2.2096 12L0.709601 17.1609C0.690553 17.2219 0.685791 17.2828 0.685791 17.3438C0.685791 17.7094 0.985791 18 1.35246 18H3.35246C3.59055 18 3.81912 17.8875 3.96198 17.7L6.01912 15H10.9191L8.58579 23.0438C8.44293 23.5219 8.8096 24 9.31436 24H11.9906C12.5382 24 13.0429 23.7094 13.3144 23.2453L18.1001 15H23.6525Z" fill="#0F417C"/>
            </svg>
          </div>
          <div class="btn-label text-16 md:text-18">
            <WFTranslate k="flights">Flights</WFTranslate>
          </div>
        </div>
        <div @click="setCurrentTab('info')">
          <div class="mainmenu-item" :class="{ active: currentTab == 'info' }">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 24C15.1826 24 18.2348 22.7357 20.4853 20.4853C22.7357 18.2348 24 15.1826 24 12C24 8.8174 22.7357 5.76516 20.4853 3.51472C18.2348 1.26428 15.1826 0 12 0C8.8174 0 5.76516 1.26428 3.51472 3.51472C1.26428 5.76516 0 8.8174 0 12C0 15.1826 1.26428 18.2348 3.51472 20.4853C5.76516 22.7357 8.8174 24 12 24ZM10.125 15.75H11.25V12.75H10.125C9.50156 12.75 9 12.2484 9 11.625C9 11.0016 9.50156 10.5 10.125 10.5H12.375C12.9984 10.5 13.5 11.0016 13.5 11.625V15.75H13.875C14.4984 15.75 15 16.2516 15 16.875C15 17.4984 14.4984 18 13.875 18H10.125C9.50156 18 9 17.4984 9 16.875C9 16.2516 9.50156 15.75 10.125 15.75ZM12 6C12.3978 6 12.7794 6.15804 13.0607 6.43934C13.342 6.72064 13.5 7.10218 13.5 7.5C13.5 7.89782 13.342 8.27936 13.0607 8.56066C12.7794 8.84196 12.3978 9 12 9C11.6022 9 11.2206 8.84196 10.9393 8.56066C10.658 8.27936 10.5 7.89782 10.5 7.5C10.5 7.10218 10.658 6.72064 10.9393 6.43934C11.2206 6.15804 11.6022 6 12 6Z" fill="#0F417C"/>
            </svg>
          </div>
          <div class="btn-label text-16 md:text-18">
            <WFTranslate k="info">Info</WFTranslate>
          </div>
        </div>
        <div @click="setCurrentTab('offers')">
          <div class="mainmenu-item" :class="{ active: currentTab == 'offers' }">
            <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18.1596 2.55898C18.7455 1.97305 18.7455 1.02148 18.1596 0.435547C17.5736 -0.150391 16.6221 -0.150391 16.0361 0.435547L1.03613 15.4355C0.450195 16.0215 0.450195 16.973 1.03613 17.559C1.62207 18.1449 2.57363 18.1449 3.15957 17.559L18.1596 2.55898ZM6.6002 2.99961C6.6002 2.20396 6.28413 1.4409 5.72152 0.878289C5.15891 0.31568 4.39584 -0.000390768 3.6002 -0.000390768C2.80455 -0.000390768 2.04148 0.31568 1.47888 0.878289C0.916266 1.4409 0.600195 2.20396 0.600195 2.99961C0.600195 3.79526 0.916266 4.55832 1.47888 5.12093C2.04148 5.68354 2.80455 5.99961 3.6002 5.99961C4.39584 5.99961 5.15891 5.68354 5.72152 5.12093C6.28413 4.55832 6.6002 3.79526 6.6002 2.99961ZM18.6002 14.9996C18.6002 14.204 18.2841 13.4409 17.7215 12.8783C17.1589 12.3157 16.3958 11.9996 15.6002 11.9996C14.8045 11.9996 14.0415 12.3157 13.4789 12.8783C12.9163 13.4409 12.6002 14.204 12.6002 14.9996C12.6002 15.7953 12.9163 16.5583 13.4789 17.1209C14.0415 17.6835 14.8045 17.9996 15.6002 17.9996C16.3958 17.9996 17.1589 17.6835 17.7215 17.1209C18.2841 16.5583 18.6002 15.7953 18.6002 14.9996Z" fill="#0F417C"/>
            </svg>
          </div>
          <div class="btn-label text-16 md:text-18">
            <WFTranslate k="offers">Offers</WFTranslate>
          </div>
        </div>
        <div @click="setCurrentTab('search')">
          <div class="mainmenu-item" :class="{ active: currentTab == 'search' }">
            <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M19.7 9.75C19.7 11.9016 19.0015 13.8891 17.825 15.5016L23.7593 21.4406C24.3453 22.0266 24.3453 22.9781 23.7593 23.5641C23.1734 24.15 22.2218 24.15 21.6359 23.5641L15.7015 17.625C14.089 18.8062 12.1015 19.5 9.94995 19.5C4.56401 19.5 0.199951 15.1359 0.199951 9.75C0.199951 4.36406 4.56401 0 9.94995 0C15.3359 0 19.7 4.36406 19.7 9.75ZM9.94995 16.5C10.8364 16.5 11.7141 16.3254 12.5331 15.9862C13.352 15.647 14.0961 15.1498 14.7229 14.523C15.3497 13.8962 15.8469 13.1521 16.1861 12.3331C16.5254 11.5142 16.7 10.6364 16.7 9.75C16.7 8.86358 16.5254 7.98583 16.1861 7.16689C15.8469 6.34794 15.3497 5.60382 14.7229 4.97703C14.0961 4.35023 13.352 3.85303 12.5331 3.51381C11.7141 3.17459 10.8364 3 9.94995 3C9.06353 3 8.18579 3.17459 7.36684 3.51381C6.54789 3.85303 5.80378 4.35023 5.17698 4.97703C4.55018 5.60382 4.05298 6.34794 3.71376 7.16689C3.37454 7.98583 3.19995 8.86358 3.19995 9.75C3.19995 10.6364 3.37454 11.5142 3.71376 12.3331C4.05298 13.1521 4.55018 13.8962 5.17698 14.523C5.80378 15.1498 6.54789 15.647 7.36684 15.9862C8.18579 16.3254 9.06353 16.5 9.94995 16.5Z" fill="#0F417C"/>
            </svg>
          </div>
          <div class="btn-label text-16 md:text-18">
            <WFTranslate k="search">Search</WFTranslate>
          </div>
        </div>
    </div>

    <SchengenZone v-if="currentTab === 'grouppois' || currentTab === 'info'"></SchengenZone>
    <FlightsMenu v-if="currentTab === 'flights'"></FlightsMenu>
  </div>
</template>

<script>

import {mapState} from "vuex";
import SchengenZone from "@/components/SchengenZone";
import FlightsMenu from "@/components/FlightsMenu";

export default {
  components: {SchengenZone, FlightsMenu},
  data() {
    return {
      current: null,
      parentGroup: null,
      topLevelGroups: [],
      count: 0
    }
  },
  props: ['locationBottom'],
  computed: {
    ...mapState('wf', ['poiGroups', 'language']),
    currentTab() {
      return this.$store.state.currentPage;
    },
  },
  methods: {
    setCurrentTab (tab) {
      this.$store.dispatch('setCurrentPage', '');
      setTimeout(() => {
        this.$store.dispatch('setCurrentPage', tab);
      }, 10);

      this.$emit('clicked', tab);
      this.$store.dispatch('setPOI', null);
    },
    setTopLevelGroup(group) {
      this.parentGroup = group;
    },
    getParentGroup() {
      if (this.topLevelGroups.length > 1) {
        return this.topLevelGroups[0];
      }
      return null;
    },
    getTopLevelGroups() {
      return this.poiGroups.reduce((result, group) => {
        if (group.showInMenu && group.getName(this.language) && group.parent_id === null && result.length < 2) {
          result.push(group);
        }
        return result;
      }, []);
    }
  },
  mounted() {
    this.topLevelGroups = this.getTopLevelGroups();
    this.parentGroup = this.getParentGroup();
  },
  watch: {
    poiGroups: function () {
      this.topLevelGroups = this.getTopLevelGroups();
      this.parentGroup = this.getParentGroup();
    },
    '$store.state.currentPage' : function() {

    },
  }
}
</script>

<style lang="postcss">
.th-menu-shadow {
  -webkit-box-shadow: 0px 4px 5px 0px rgba(0,0,0,0.2);
  -moz-box-shadow: 0px 4px 5px 0px rgba(0,0,0,0.2);
  box-shadow: 0px 4px 5px 0px rgba(0,0,0,0.2);
  padding-bottom: 10px;
}
.th-menu-shadow-up {
  -webkit-box-shadow: 0px -3px 5px 0px rgba(0,0,0,0.2);
  -moz-box-shadow: 0px -3px 5px 0px rgba(0,0,0,0.2);
  box-shadow: 0px -3px 5px 0px rgba(0,0,0,0.2);
  padding-top: 10px;
}
.mainmenu-item {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 5.6rem;
  height: 5.6rem;

  border-radius: 50%;
  border: 1px solid #0F417C;
  position: relative;

  svg {
    height: 2.3rem;
    width: 2.3rem !important;
    margin: auto;
  }

  &.active {
     background: #0F417C;

    svg {
      path {
        fill: #fff !important;
      }
    }
  }

}
</style>
